import styles from './main-nav.module.css';
import { Home, LayoutGrid, LifeBuoy } from 'lucide-react';
import { Link, useLocation } from 'wouter';

export const MainNav = () => {
  const [location] = useLocation();

  return (
    <nav className={ styles.mainNav }>
      <Link to="/" data-active={ location === '/' }>
        <Home />
        <span>Home</span>
      </Link>
      <Link to="/gallery" data-active={ location === '/gallery' }>
        <LayoutGrid />
        <span>Gallery</span>
      </Link>
      <Link to="/help" data-active={ location === '/help' }>
        <LifeBuoy />
        <span>Help</span>
      </Link>
    </nav>
  );
};